module.exports = __webpack_public_path__ + "static/media/detectorActive.1bf5f610.png";